import { useExperience } from '@cascade/react/experiences';
import { useEffect } from 'react';
import classes from './Experience.module.scss';
import { ExperienceChat } from './experience-chat/index.ts';
import { ExperienceStep } from './experience-step/index.ts';
import { ExperienceStepper } from './experience-stepper/index.ts';
import { StepNavigation } from './step-navigation/index.ts';
import { Page } from '#components/page/index.ts';
import { useLayout } from '#layout/index.ts';

export const Experience = () => {
  const { experience } = useExperience();
  const { closeSidebar } = useLayout();

  useEffect(() => {
    closeSidebar();
  }, [closeSidebar]);

  return (
    <Page iconType='sparkle' title={experience?.title ?? ''}>
      <div className={classes.experience}>
        <ExperienceStepper />
        <ExperienceStep />
        <StepNavigation />
      </div>
      <ExperienceChat />
    </Page>
  );
};
